import { Navigate } from "react-router"

// Legacy route kept so old invite emails landing on /set-password still work.
// The actual set-password UI lives at /welcome/password (step 1 of the
// invitee welcome flow) where it sits inside WelcomeShell with the team/role
// badge — making it consistent with the rest of the welcome wizard.
export default function SetPasswordPage() {
  return <Navigate to="/welcome/password" replace />
}
